module.exports = {"231003001":"阳明街道","231003002":"前进街道","231003003":"新兴街道","231003004":"桦林橡胶厂街道","231003100":"铁岭镇","231003101":"桦林镇","231003102":"磨刀石镇","231003103":"五林镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231003.json
// module id = 871
// module chunks = 0